import { PageHeader } from '../../../components/page-header';
import { TableView } from '../../../components/table-view';
import { serviceDescriptionColumns } from './_mockdata';
import { Button, IconButton, Stack } from '@mui/material';
import { SearchField } from '../../../components/fields';
import { useDialog } from '../../../core/hooks/useDialog';
import { ServiceDescriptionEditDialog } from './ServiceDescriptionEditDialog';
import { IconPen, IconTrash } from '../../../components/icons';
import { ConfirmDialog } from '../../../components/dialogs/ConfirmDialog';
import { useLayout } from '../../../core/hooks/useLayout';
import { ROUTE_MASTER_DATA } from '../../../constants/route.paths';
import { useListResource } from '../../../core/hooks/useListResource';
import get from 'lodash/get';
import { ServiceDescriptionApi } from '../../../core/http';
import { useDispatch } from 'react-redux';
import { forceFetchServiceDescription } from '../../../core/store/slices/serviceDescriptionSlice';

const serviceDescriptionApi = new ServiceDescriptionApi();

export const ServiceDescriptionContainer = () => {
  const [openEdit, closeEdit] = useDialog(ServiceDescriptionEditDialog);
  const [openConfirm, closeConfirm] = useDialog(ConfirmDialog);
  const dispatch = useDispatch();

  useLayout({
    backButton: {
      title: 'Master Data',
      path: ROUTE_MASTER_DATA
    }
  });

  const {
    data,
    isLoading,
    fetchData,
    deleteRecord,
    pagination,
    handleChangePage,
    handleChangePerPage,
    handleChangeParams
  } = useListResource(serviceDescriptionApi);

  const handleDelete = (uuid: string) => () => {
    openConfirm({
      title: 'Delete',
      message: 'Do you really want to delete this record?',
      onConfirm: () => {
        deleteRecord(uuid).then(() => {
          fetchData();
          dispatch(forceFetchServiceDescription());
          closeConfirm();
        });
      }
    });
  };

  const handleOpenEdit =
    (uuid = '') =>
    () => {
      openEdit({
        uuid,
        onSuccess: () => {
          fetchData();
          dispatch(forceFetchServiceDescription());
          closeEdit();
        }
      });
    };

  return (
    <>
      <PageHeader title="Service Description" />

      <Stack direction="row" justifyContent="space-between" mb={3}>
        <Button onClick={handleOpenEdit()}>Add new</Button>
        <SearchField
          placeholder="Search"
          sx={{ maxWidth: 400 }}
          onChange={(value) => {
            handleChangeParams('search', value || null);
          }}
        />
      </Stack>

      <TableView
        showEmptyState
        loading={isLoading}
        pagination={pagination}
        onChangePage={handleChangePage}
        onChangePerPage={handleChangePerPage}
        keyExtractor={(item: any) => item.uuid}
        dataSource={get(data, 'items', [])}
        columns={[
          ...serviceDescriptionColumns,
          {
            title: '',
            dataIndex: 'actions',
            key: 'actions',
            cellProps: {
              width: 40
            },
            render: (_, { uuid }) => (
              <Stack direction="row" alignItems="center">
                <IconButton size="small" onClick={handleOpenEdit(uuid)}>
                  <IconPen />
                </IconButton>
                <IconButton size="small" onClick={handleDelete(uuid)}>
                  <IconTrash />
                </IconButton>
              </Stack>
            )
          }
        ]}
      />
    </>
  );
};
